export const getBuyersWithMovements =
  'Merchant/GetBuyersWithMovementsForMerchant';
